import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/About.css'; // Assurez-vous de créer et d'utiliser ce fichier CSS pour ajouter des styles personnalisés

const About = () => {
    return (
        <>
            <div className="about-header bg-primary text-white text-center py-5">
                <h1 className="display-4">À propos</h1>
            </div>
            <div className="container my-5">
                <div className="row">
                    <div className="col-lg-8 mx-auto">
                        <p className="lead">Le groupe CONSULT-IT est un acteur international de la transformation et de la performance des entreprises qui ambitionne de se positionner comme le partenaire stratégique de ses clients en les accompagnant dans l’analyse et la valorisation de leurs données, le développement et la maîtrise de leur expérience digitale.</p>
                        <p>CONSULT-IT intervient dans des secteurs variés et accompagne les entreprises dans la réalisation des missions d’audit et de conseil pour améliorer et optimiser leurs systèmes d’information.</p>
                        <p>CONSULT-IT est résolument tourné vers l’innovation et propose à ses clients un portefeuille intégré de services d’informatiques.</p>
                        <p>Présent en France, au Maroc, en Tunisie et en Egypte, le groupe CONSULT-IT est marqué par sa volonté d’offrir à ses clients une panoplie de services toujours plus large, des transitions de technologies traditionnelles aux technologies les plus récentes et des synergies toujours plus poussées.</p>
                        <p>Le périmètre d’expertise de CONSULT-IT s’accroit via la mutualisation continue de ses moyens et de ses ressources ainsi que de ses partenariats privilégiés avec de grands Editeurs mondiaux.</p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default About;
